"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combine = void 0;
function combine(reducers) {
    return function (state, action) {
        const nextState = { ...state };
        Object.keys(reducers).forEach(key => {
            nextState[key] = state[key];
            reducers[key].forEach(reducer => {
                nextState[key] = reducer(nextState[key], action);
            });
        });
        return nextState;
    };
}
exports.combine = combine;
//# sourceMappingURL=redux.combine.js.map